import { memo } from "react";
import type { FC } from "react";
import { Typography } from "@mui/material";
//import { Icon2 } from './Icon2';
//import { Icon } from './Icon';
import { Grid } from "@mui/material";
import classes from "./LandingHome.module.css";
import { BasicViewer } from "../../Modules/Viewer/BasicViewer";
import { dicomT2Wset } from "../../Functions/Dicom/readHeadT2w";
import { MstaFontFamily } from "../../Functions/Style/MstaFont";
import { MstaButton } from "../../Functions/Style/ButtonStyle";
import { isMobile, isTablet } from "react-device-detect";
import FaceIcon from "@mui/icons-material/Face";
import Face3Icon from "@mui/icons-material/Face3";
import Face4Icon from "@mui/icons-material/Face4";
import Face6Icon from "@mui/icons-material/Face6";
import { FukidashiIcon } from "./Icon2";
import { useWindowDimensions } from "../../Functions/ScreenOperation/useWindowDimension";
import msta from "../../Images/logo_msta.svg";
import syoureiPage from "../../Images/msta_catalogue.png";
import basicPage from "../../Images/msta_basic.png";
import { lightBlue } from "@mui/material/colors";

interface Props {
  className?: string;
}

/* @figmaId 6:453 */
const Home: FC<Props> = memo(function LandingPageHome(props = {}) {
  const { height } = useWindowDimensions();

  let tabletViewerMargin = isMobile ? 3 : isTablet ? 16 : 0;

  const handleOpenLink = (url: string) => {
    const toUrl = url;
    window.location.href = toUrl;
  };

  return (
    <Grid
      direction={"column"}
      justifyContent={"center"}
      alignItems={"center"}
      width={{ xs: "90%", md: "70%" }}
      mx={"auto"}
    >
      <Grid
        direction={"column"}
        justifyContent={"center"}
        alignItems={"center"}
      >
        <Grid mt={8} mb={4}>
          <img
            src={msta}
            alt="Msta Logo"
            style={{ maxWidth: "50vw", maxHeight: "40vh" }}
          />
        </Grid>

        <Typography
          align="center"
          fontFamily={MstaFontFamily}
          className={classes.msta}
          fontWeight={"bold"}
          mb={3}
          sx={{
            fontSize: "2.5rem",
          }}
        >
          CT・MRIがもっとわかる！
        </Typography>

        <Typography
          variant="h5"
          align="center"
          fontFamily={MstaFontFamily}
          className={classes.msta}
          mb={5}
          sx={{
            fontSize: "1rem",
          }}
        >
          Mstaは学生が作った新しく実践的な画像診断学習アプリです。
        </Typography>
        <MstaButton
          variant="contained"
          className="lectureMenuButton"
          size="small"
          sx={{
            mb: { sm: 2, xs: 1 },
            height: { xs: 40, sm: 60 },
            fontSize: { xs: 16, sm: 20 },
          }}
          onClick={() => handleOpenLink("login")}
        >
          今すぐ始める
        </MstaButton>
      </Grid>
      <Grid mx={"auto"} mt={10}>
        <Typography
          variant="h4"
          fontWeight={"bold"}
          sx={{ color: lightBlue[400], fontSize: "2rem" }}
          mb={3}
        >
          豊富な症例を掲載
        </Typography>
        <Typography
          variant="h5"
          align="center"
          fontFamily={MstaFontFamily}
          className={classes.msta}
          sx={{
            fontSize: "1rem",
          }}
          lineHeight={1.5}
          mb={0.5}
        >
          メジャーな疾患からマイナーな疾患まで幅広くカバーしています。
        </Typography>
        <Typography
          variant="h5"
          align="center"
          fontFamily={MstaFontFamily}
          className={classes.msta}
          sx={{
            fontSize: "1rem",
          }}
          lineHeight={1.5}
          mb={0.5}
        >
          医学生の試験対策や、類似症例を見たい時に活用できます。
        </Typography>
      </Grid>
      <Grid mx={"auto"} mb={10}>
        <img src={syoureiPage} style={{ width: "100%" }} />
      </Grid>
      <Grid
        container
        direction={"column"}
        justifyContent={"center"}
        alignItems={"center"}
        mb={10}
        mx={"auto"}
      >
        <Typography
          variant="h4"
          fontWeight={"bold"}
          sx={{ color: lightBlue[400], fontSize: "2rem" }}
          mb={3}
        >
          画像を動かして、実践的な読影力を身につける
        </Typography>
        <Typography
          variant="h5"
          align="center"
          fontFamily={MstaFontFamily}
          className={classes.msta}
          sx={{
            fontSize: "1rem",
          }}
          lineHeight={1.5}
          mb={0.5}
        >
          実際の医療現場と同じビューアーを使うことができます。
        </Typography>
        <Typography
          variant="h5"
          align="center"
          fontFamily={MstaFontFamily}
          className={classes.msta}
          sx={{
            fontSize: "1rem",
          }}
          lineHeight={1.5}
          mb={0.5}
        >
          画像をスクロールして前後の断面を確認することで、立体的にイメージできます。
        </Typography>
        <Grid
          item
          // xs={11}
          width={{ xs: "100%", sm: "90%"}}
          // height={{ lg: height > 2000 ? 600 : 350, md: 320, xs: 300 }}
          alignItems={"center"}
          mt={4}
          mb={2}
        >
          <BasicViewer imageIds={dicomT2Wset} width="maxContent" height="50vh" />
        </Grid>
        <Typography
          variant="h5"
          align="center"
          fontFamily={MstaFontFamily}
          className={classes.textBlock}
          sx={{
            fontSize: "1rem",
          }}
        >
          実際に画像をスクロールできます。
        </Typography>
      </Grid>
      <Grid mx={"auto"}>
        <Typography
          variant="h4"
          fontWeight={"bold"}
          mb={3}
          sx={{ color: lightBlue[400], fontSize: "2rem" }}
        >
          動画解説で正常画像を学ぶ
        </Typography>
        <Typography
          variant="h5"
          align="center"
          fontFamily={MstaFontFamily}
          className={classes.msta}
          sx={{
            fontSize: "1rem",
          }}
          lineHeight={1.5}
          mb={0.5}
        >
          現役の放射線科医による解説動画を見ながら、正常画像を学ぶことができます。
        </Typography>
        <Typography
          variant="h5"
          align="center"
          fontFamily={MstaFontFamily}
          className={classes.msta}
          mb={4}
          sx={{
            fontSize: "1rem",
          }}
          lineHeight={1.5}
        >
          諸学者や画像に苦手意識がある方でも、レクチャーを受けている感覚で勉強できます。
        </Typography>
      </Grid>
      <Grid mx={"auto"} mb={10}>
        <img src={basicPage} style={{ width: "100%" }} />
      </Grid>
      <Grid mx={"auto"} mb={10}>
        <Typography fontSize={"2rem"} fontWeight={"bold"} mb={3}>
          ユーザーの声
        </Typography>
        <Grid
          container
          width={"100%"}
          display={"grid"}
          alignItems={"center"}
          justifyContent={"center"}
          gridTemplateColumns={{ sm: "45% 45%", xs: "100%" }}
          gap={2}
        >
          <Grid
            item
            display="flex"
            gap={2}
            p={2}
            justifyContent={"center"}
            alignItems={"center"}
            border={"solid"}
            borderRadius={"16px"}
            minHeight={150}
            maxHeight={150}
          >
            <Grid display="grid" width={"30%"}>
              <FaceIcon sx={{ fontSize: "3rem" }}></FaceIcon>
              <Typography
                variant="subtitle1"
                align="left"
                fontFamily={MstaFontFamily}
                fontSize={{ xs: "1rem", sm: "0.8rem" }}
              >
                医学生5年Aさん
              </Typography>
            </Grid>
            <Grid
              display={"flex"}
              height={{ md: 80, xs: 60 }}
              width={{ md: 300, xs: 250 }}
              style={{ position: "relative" }}
              alignItems={"center"}
            >
              {/*<Icon className={classes.icon} style={{ position: 'absolute', top: 0, left: 0, zIndex: 1 }}/>*/}
              <Typography
                variant="subtitle1"
                align="left"
                fontFamily={MstaFontFamily}
                style={
                  {
                    /*position: 'absolute', top:15, left: 50, zIndex: 2*/
                  }
                }
                fontSize={{ xs: "1rem", md: "1rem" }}
              >
                言葉では分かりにくかった部分が画像を見ることで理解できました！
              </Typography>
            </Grid>
          </Grid>

          <Grid
            item
            display="flex"
            gap={2}
            p={2}
            justifyContent={"center"}
            alignItems={"center"}
            border={"solid"}
            borderRadius={"16px"}
            minHeight={150}
            maxHeight={150}
          >
            <Grid display="grid" width={"30%"}>
              <Face4Icon sx={{ fontSize: "3rem" }}></Face4Icon>
              <Typography
                variant="subtitle1"
                align="left"
                fontFamily={MstaFontFamily}
                fontSize={{ xs: "1rem", sm: "0.8rem" }}
              >
                研修医1年目Bさん
              </Typography>
            </Grid>
            <Grid
              display={"flex"}
              height={{ md: 80, xs: 60 }}
              width={{ md: 300, xs: 250 }}
              style={{ position: "relative" }}
              alignItems={"center"}
            >
              {/*<Icon2 className={classes.icon} style={{ position: 'absolute', top: 0, left: 0, zIndex: 1 }}/>*/}
              <Typography
                variant="subtitle1"
                align="left"
                fontFamily={MstaFontFamily}
                style={
                  {
                    /*position: 'absolute', top: 15, left: 50, zIndex: 2 */
                  }
                }
                fontSize={{ xs: "1rem", md: "1rem" }}
              >
                実際の患者さんを診ているような感覚になります！
              </Typography>
            </Grid>
          </Grid>
          <Grid
            item
            display="flex"
            gap={2}
            p={2}
            justifyContent={"center"}
            alignItems={"center"}
            border={"solid"}
            borderRadius={"16px"}
            minHeight={150}
            maxHeight={150}
          >
            <Grid display="grid" width={"30%"}>
              <Face6Icon
                sx={{ fontSize: "3rem" }}
              ></Face6Icon>
              <Typography
                variant="subtitle1"
                align="left"
                fontFamily={MstaFontFamily}
                fontSize={{ xs: "1rem", sm: "0.8rem" }}
              >
                医学生3年Cさん
              </Typography>
            </Grid>
            <Grid
              display={"flex"}
              height={{ md: 80, xs: 60 }}
              width={{ md: 300, xs: 250 }}
              style={{ position: "relative" }}
              alignItems={"center"}
            >
              <Typography
                variant="subtitle1"
                align="left"
                fontFamily={MstaFontFamily}
                fontSize={{ xs: "1rem", md: "1rem" }}
              >
                CTやMRIに対する抵抗がなくなりました！
              </Typography>
            </Grid>
          </Grid>
          <Grid
            item
            display="flex"
            gap={2}
            p={2}
            justifyContent={"center"}
            alignItems={"center"}
            border={"solid"}
            borderRadius={"16px"}
            minHeight={150}
            maxHeight={150}
          >
            <Grid display="grid" width={"30%"}>
              <Face3Icon sx={{ fontSize: "3rem" }}></Face3Icon>
              <Typography
                variant="subtitle1"
                align="left"
                fontFamily={MstaFontFamily}
                fontSize={{ xs: "1rem", sm: "0.8rem" }}
              >
                研修医2年目Dさん
              </Typography>
            </Grid>
            <Grid
              display={"flex"}
              height={{ md: 80, xs: 60 }}
              width={{ md: 300, xs: 250 }}
              style={{ position: "relative" }}
              alignItems={"center"}
            >
              <Typography
                variant="subtitle1"
                align="left"
                fontFamily={MstaFontFamily}
                fontSize={{ xs: "1rem", md: "1rem" }}
              >
                いつの間にか、画像診断が楽しくなっていた！
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid mx={"auto"} mb={10}>
        <Typography
          variant="h5"
          fontWeight={"bold"}
          mb={3}
          sx={{
            fontSize: "2rem",
          }}
        >
          見る人から、診る人へ
        </Typography>
        <Typography
          variant="h5"
          align="center"
          fontFamily={MstaFontFamily}
          className={classes.msta}
          sx={{
            fontSize: "1.0rem",
          }}
          lineHeight={1.5}
          mb={0.5}
        >
          「今持っている教科書は１枚のキー画像でしかなく、立体構造がわかりにくい」
        </Typography>
        <Typography
          variant="h5"
          align="center"
          fontFamily={MstaFontFamily}
          className={classes.msta}
          sx={{
            fontSize: "1.0rem",
          }}
          lineHeight={1.5}
          mb={0.5}
        >
          「画像診断は正常画像の理解が前提で、初学者にはとっつきにくい」
        </Typography>
        <Typography
          variant="h5"
          align="center"
          fontFamily={MstaFontFamily}
          className={classes.msta}
          sx={{
            fontSize: "1.0rem",
          }}
          lineHeight={1.5}
          mb={3.0}
        >
          そんな医学生の声からMstaは生まれました。
        </Typography>
        <Typography
          variant="h5"
          align="center"
          fontFamily={MstaFontFamily}
          className={classes.msta}
          sx={{
            fontSize: "1.0rem",
          }}
          lineHeight={1.5}
          mb={0.5}
        >
          Mstaは「画像診断は専門性が高く、難しい」というイメージを払拭し、
        </Typography>
        <Typography
          variant="h5"
          align="center"
          fontFamily={MstaFontFamily}
          className={classes.msta}
          sx={{
            fontSize: "1.0rem",
          }}
          lineHeight={1.5}
          mb={0.5}
        >
          あなたを「見る人」から「診る人」へ導きます。
        </Typography>
        <Typography
          variant="h5"
          align="center"
          fontFamily={MstaFontFamily}
          className={classes.msta}
          sx={{
            fontSize: "1.0rem",
          }}
          lineHeight={1.5}
          mb={0.5}
        >
          ぜひご活用ください！
        </Typography>
      </Grid>
      <Grid mx={"auto"} mb={16}>
        <Typography variant="h4" fontWeight={"bold"} mb={4}>
          Mstaで画像診断を学ぼう
        </Typography>
        <MstaButton
          variant="contained"
          className="lectureMenuButton"
          size="small"
          sx={{
            mb: { sm: 2, xs: 1 },
            height: { xs: 40, sm: 60 },
            fontSize: { xs: 16, sm: 20 },
          }}
          onClick={() => handleOpenLink("login")}
        >
          今すぐ始める
        </MstaButton>
      </Grid>
    </Grid>
  );
});

export default function LoadingHome(): JSX.Element {
  return (
    <div>
      <Home />
    </div>
  );
}
